export function formatPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length !== 10) return value || '';
  return `${ten.slice(0, 3)}-${ten.slice(3, 6)}-${ten.slice(6)}`;
}

export function mapsUrl(address) {
  const value = String(address || '').trim();
  if (!value) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(value)}`;
}

export function formatPreferredWindow(value) {
  const labels = {
    morning_8_12: 'Morning 8am - 12pm',
    midday_10_2: 'Midday 10am - 2pm',
    afternoon_12_4: 'Afternoon 12pm - 4pm',
    evening_4_7: 'Evening 4pm - 7pm',
    flexible: 'Flexible',
  };
  return labels[value] || String(value || '').replaceAll('_', ' ');
}